import { IconComponentProps } from './index'

const Read = ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} className={customClass} viewBox="0 0 24 16" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M10 15C10 11.13 13.13 8 17 8C18.08 8 19.09 8.25 20 8.68V2C20 0.9 19.1 0 18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H10.08C10.03 15.67 10 15.34 10 15ZM2 2L10 7L18 2V4L10 9L2 4V2ZM15.34 18L11.8 14.46L13.21 13.05L15.33 15.17L19.57 10.93L21 12.34L15.34 18Z" fill="#2B3346"/>
  </svg>
)

export default Read
